<div class="form-group row">
  <label [attr.for]="id" class="col-3 col-form-label" *ngIf="showWrapperLabel">
    {{ to.label }}
    <span class="k-required" *ngIf="to.required && to.hideRequiredMarker !== true">*</span>
  </label>
  <div [ngClass]="showWrapperLabel ? 'col-9' : 'col-12'">
    <ng-template #fieldComponent></ng-template>
    <div *ngIf="showError" class="col-12 validation-feedback k-required d-block" style="position:relative;top:-20px;">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  </div>
</div>